/*
 * Automatically wraps trademark/registered/service-mark symbols (® ™ ℠)
 * in <sup> tags wherever they appear in the page, including content that
 * loads in after page load (cart bar, cart drawer, quick-add, variant swaps).
 */
(function () {
  var MARK_RE = /[®™℠]/;
  var SKIP_TAGS = {
    SCRIPT: 1,
    STYLE: 1,
    TEXTAREA: 1,
    INPUT: 1,
    NOSCRIPT: 1,
    SUP: 1,
    SELECT: 1,
    IFRAME: 1
  };

  function wrapNode(textNode) {
    if (!textNode.parentNode) return;
    var text = textNode.nodeValue;
    if (!MARK_RE.test(text)) return;

    var frag = document.createDocumentFragment();
    var parts = text.split(/([®™℠])/);

    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (part === '') continue;
      if (part === '®' || part === '™' || part === '℠') {
        var sup = document.createElement('sup');
        sup.className = 'trademark-sup';
        sup.textContent = part;
        frag.appendChild(sup);
      } else {
        frag.appendChild(document.createTextNode(part));
      }
    }

    textNode.parentNode.replaceChild(frag, textNode);
  }

  function processElement(root) {
    if (!root || root.nodeType !== 1 || SKIP_TAGS[root.tagName]) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parentTag = node.parentNode && node.parentNode.tagName;
        if (parentTag && SKIP_TAGS[parentTag]) return NodeFilter.FILTER_REJECT;
        if (!MARK_RE.test(node.nodeValue)) return NodeFilter.FILTER_SKIP;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) wrapNode(nodes[i]);
  }

  function init() {
    processElement(document.body);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            processElement(node);
          } else if (node.nodeType === 3 && MARK_RE.test(node.nodeValue)) {
            var parentTag = node.parentNode && node.parentNode.tagName;
            if (!parentTag || !SKIP_TAGS[parentTag]) wrapNode(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
